import { useState, useEffect } from 'react';
import API_CIFRA from '../config/Variables_apis';

/**
 * Clima real (Open-Meteo, sin API key) por coordenadas — usado por la marca
 * de agua de evidencia (HU-005 Fase 3). Si la API falla o no responde,
 * `temperature`/`weatherCode` quedan en `null` — a propósito ya NO se
 * simula un valor al azar (bug real corregido en HU-005: una foto de
 * evidencia terminaba mostrando una temperatura inventada que parecía
 * real). El llamador decide qué hacer con `null` — para la marca de agua,
 * significa "omitir esa línea", nunca "inventar un número".
 */
export const useWeather = (latitude, longitude) => {
  const [temperature, setTemperature] = useState(null);
  const [weatherCode, setWeatherCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!latitude || !longitude) {
      setTemperature(null);
      return;
    }

    const fetchTemperature = async () => {
      setLoading(true);
      setError(null);
      
      try {
        // Usar OpenWeatherMap API desde configuración
        const url = API_CIFRA.weather.currentWeather(latitude, longitude);
        
        const response = await fetch(url);
        const data = await response.json();
        
        if (response.ok && data.current) {
          if (data.current.temperature_2m != null) {
            setTemperature(Math.round(data.current.temperature_2m));
          }
          if (data.current.weather_code != null) {
            setWeatherCode(data.current.weather_code);
          }
        } else {
          console.warn('Open-Meteo API no disponible — sin dato de clima real, no se inventa uno.');
          setError('Clima no disponible');
        }
      } catch (error) {
        console.warn('No se pudo obtener el clima real — sin dato, no se inventa uno.', error);
        setError(error.message || 'Clima no disponible');
      } finally {
        setLoading(false);
      }
    };

    fetchTemperature();
  }, [latitude, longitude]);

  return { temperature, weatherCode, loading, error };
};
